import {use} from 'react';

import {AuditImageSelectionContext} from '../AuditImageSelectionContext';
import {TAuditImageSelectionContext} from '../types/TAuditImageSelectionContext';

export const useAuditImageSelectionContext = (): TAuditImageSelectionContext =>
  use(AuditImageSelectionContext);
